import { usePage } from '@inertiajs/react';
import type { SharedProps } from '../types';
import type { WikiNav } from '../types/wiki';

// 读左边栏那份共享数据（`Web::WikisController` 的 `inertia_share`）。
//
// 有两个读者（`Wiki/Sidebar.tsx` 与列表页页头那两个数），所以这一行 cast 在
// hook 里，不在两处各写一遍 —— `SharedProps` 上的索引签名是 `unknown`，
// 每个调用方自己 cast 就是两处各写一次同一个类型断言。
//
// 可能是 undefined：局部重载（`router.reload({ only: […] })`）会按 dot 路径把
// 没被点名的共享 props 整块滤掉。调用方要么整块不渲染，要么给兜底 —— 不要在
// 这里造一个空对象，那会把「没拿到数据」伪装成「库是空的」。
export default function useWikiNav(): WikiNav | undefined {
  return usePage<SharedProps>().props.wikiNav as WikiNav | undefined;
}
